"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _Input = _interopRequireDefault(require("../../Input"));

var _deprecatedThemeProps = _interopRequireDefault(require("../../Input/theme/deprecatedThemeProps"));

var _themeBus = _interopRequireDefault(require("../../Input/theme/themeBus"));

var _mergeTheme = _interopRequireDefault(require("../../style/mergeTheme"));

var _pick = _interopRequireDefault(require("lodash/pick"));

var _pixelToNumber = _interopRequireDefault(require("../../style/pixelToNumber"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var allowedToPassIntoInputStyle = ['fontSize', 'lineHeight', 'paddingLeft', 'paddingRight', 'fontFamily', 'color', 'fontWeight', 'placeholder', 'background', 'palette'];

var PhoneNumberInput = function PhoneNumberInput(_ref) {
  var style = _ref.style,
      theme = _ref.theme,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["style", "theme"]);
  var styleMemo = (0, _react.useMemo)(function () {
    if (style) {
      // TODO remove in next major version. current 9.8
      var props = Object.keys(style);

      if (props.find(function (key) {
        return _deprecatedThemeProps["default"].includes(key);
      })) {
        style = (0, _themeBus["default"])(style);
      }
    }

    var computed = (0, _mergeTheme["default"])((0, _pick["default"])(theme, allowedToPassIntoInputStyle), style);
    return _objectSpread({
      boxSizing: 'border-box'
    }, computed, {
      // padding left throws to DropDownSearch. there is no paddingLeft usage here.
      paddingLeft: 0,
      paddingRight: computed.paddingRight,
      width: "calc(100% - ".concat(computed.palette.gutter * 12 + (0, _pixelToNumber["default"])(computed.paddingLeft), "px)"),
      borderStyle: 'none',
      borderWidth: 0,
      boxShadow: 'none',
      hover: {
        borderStyle: 'none',
        borderWidth: 0,
        boxShadow: 'none'
      },
      focus: {
        borderStyle: 'none',
        borderWidth: 0,
        boxShadow: 'none'
      },
      error: {
        borderStyle: 'none',
        borderWidth: 0,
        boxShadow: 'none'
      },
      disabled: {
        borderStyle: 'none',
        borderWidth: 0,
        boxShadow: 'none'
      }
    });
  }, [style]);
  return _react["default"].createElement(_Input["default"], (0, _extends2["default"])({
    style: styleMemo
  }, rest, {
    underscore: false
  }));
};

var _default = PhoneNumberInput;
exports["default"] = _default;